export const search = {
  name: "search" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M11 3.9a7.1 7.1 0 0 0-7.1 7.105 7.096 7.096 0 0 0 7.105 7.095 7.072 7.072 0 0 0 7.095-7.095A7.1 7.1 0 0 0 11 3.9Zm-8.9 7.105C2.1 6.088 6.081 2.1 11 2.1c4.919 0 8.9 3.988 8.9 8.905 0 2.13-.742 4.09-1.991 5.624l4.228 4.235a.9.9 0 0 1-1.274 1.272l-4.226-4.233a8.875 8.875 0 0 1-5.632 1.997c-4.917 0-8.905-3.975-8.905-8.895Z" clip-rule="evenodd"/></svg>`,
  keywords: ["search"],
  category: "utility" as const,
};
